import React from 'react';
import styled from "styled-components";
import {Container} from "../shared";
import initScripts from './scripts';


const Root = styled.div`
  min-height: 100vh;
  padding-top: 70px;
  padding-bottom: 40px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeroText = styled.div`
  font-size: 56px;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 500;
  line-height: 1;
  color: #0E1013;
  
  @media only screen and (min-width: 501px) {
    text-align: center;
    text-shadow:  0px 4px 8px #f9f7f4;
  }
`;

const HeroBackground = styled.div`
  position: absolute;
  top: 75px;
  left: 5px;
  right: 5px;
  bottom: 5px;
`;

const Button = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  color: white;
  width: auto;
  height: 50px;
  border-radius: 8px;
  background-color: #eb0b1a;
  border-radius: 50px;
  padding: 1.5em;
`;

const Panel1 = () => {
  React.useEffect(() => {
    initScripts();
  }, [])

  return (
    <Root>
      <HeroBackground id="particles-js" />
      <Container>
        <HeroText>
          Solving <span style={{ color: '#eb0b1a', fontFamily: 'Space Grotesk' }}>tomorrow’s problems</span><br/>
          for the world’s biggest brands
        </HeroText>
        <div style={{ marginTop: 60, display: 'flex', justifyContent: 'center'}}>
          <a href="https://burnsred.com.au/evolveai/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
            <Button>
              Introducing Evolve AI →
            </Button>
          </a>
        </div>
      </Container>
    </Root>
  )
};

export default Panel1;
